// extracted by mini-css-extract-plugin
export default {"employee-container":"Earning_employee-container__AtDER"};